var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 9.29007L12 13.1701L8.11999 9.29007C8.02741 9.19749 7.9175 9.12405 7.79653 9.07394C7.67557 9.02384 7.54592 8.99805 7.41499 8.99805C7.28406 8.99805 7.15441 9.02384 7.03345 9.07394C6.91248 9.12405 6.80257 9.19749 6.70999 9.29007C6.61741 9.38265 6.54397 9.49256 6.49386 9.61352C6.44376 9.73449 6.41797 9.86414 6.41797 9.99507C6.41797 10.126 6.44376 10.2556 6.49386 10.3766C6.54397 10.4976 6.61741 10.6075 6.70999 10.7001L11.3 15.2901C11.69 15.6801 12.32 15.6801 12.71 15.2901L17.3 10.7001C17.3927 10.6076 17.4662 10.4977 17.5164 10.3767C17.5666 10.2557 17.5924 10.126 17.5924 9.99507C17.5924 9.8641 17.5666 9.73442 17.5164 9.61344C17.4662 9.49247 17.3927 9.38258 17.3 9.29007C16.91 8.91007 16.27 8.90007 15.88 9.29007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.f7d7cbb93e488be71080558f413d2665.svg";
export { ForwardRef as ReactComponent };